import React, { useState } from "react";
import { styled } from "@glitz/react";
import { spacing, fontWeight, red, fontSize, darkGrey } from "../theme";
import Input from "./basic/TextInput";
import Button from "./basic/Button";
import Checkbox from "./basic/Checkbox";
import { useCart } from "../context/CartContext";

interface DiscountSectionProps {}

const DiscountSection = ({}: DiscountSectionProps) => {
  const [discountCode, setDiscountCode] = useState<string>("");
  const [discountCodeError, setDiscountCodeError] = useState<string>("");
  const [isChecked, setIsChecked] = useState(false);

  const { applyCoupon, removeCoupon, couponCode, packageOrderActive } = useCart();

  const handleApplyCoupon = async () => {
    if (!discountCode) {
      setDiscountCodeError("Lägg till en kod");
      return;
    }

    try {
      setDiscountCodeError("");
      await applyCoupon(discountCode);
    } catch (err: any) {
      console.error(err);
      setDiscountCodeError(
        err?.message && typeof err.message === "string"
          ? err.message
          : "Fel vid aktivering av rabattkod"
      );
    }
  };

  const handleToggle = (checked: boolean) => {
    setIsChecked(checked);

    if (!checked) {
      removeCoupon();
      setDiscountCode("");
      setDiscountCodeError("");
    }
  };

  if (packageOrderActive) {
    return (
      <Content>
        <PackageNote>
          Rabattkod kan inte användas tillsammans med energipaket — paketpriset är redan
          rabatterat mot ordinarie pris.
        </PackageNote>
      </Content>
    );
  }

  return (
    <Content>
      <Checkbox
        label="Använd rabattkod"
        checked={isChecked}
        onChange={handleToggle}
      />
      {isChecked && (
        <Wrapper>
          <Input
            label="Ange rabattkod"
            value={discountCode}
            onChange={(e) => setDiscountCode(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === "Enter") handleApplyCoupon();
            }}
          />
          <Button onClick={handleApplyCoupon}>Aktivera Rabattkod</Button>
          {discountCodeError && <ErrorText>{discountCodeError}</ErrorText>}
          {couponCode && (
            <SuccessText>Rabattkod "{couponCode}" aktiverad!</SuccessText>
          )}
        </Wrapper>
      )}
    </Content>
  );
};

const Content = styled.div({
  display: "flex",
  flexDirection: "column",
  justifySelf: "center",
  gap: spacing.m,
});

const Wrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.xs,
});

const ErrorText = styled.div({
  color: red,
  fontWeight: fontWeight.light,
  fontSize: fontSize.s,
});

const SuccessText = styled.div({
  color: "green",
  fontWeight: fontWeight.light,
  fontSize: fontSize.s,
});

const PackageNote = styled.p({
  fontSize: fontSize.s,
  color: darkGrey,
  lineHeight: "1.5",
  margin:{xy: 0},
});

export default DiscountSection;
